import useSetupMode from "./useSetupMode";
import { useCanUserDoOnProject } from "../canUserDo";

export default function useProjectSetupMode(projectId: string) {
  const { canEnableSetupMode, isSetupModeEnabled } = useSetupMode();
  const hasSetupPermission = useCanUserDoOnProject("PROJECT_SETUP", projectId);
  const canEnableSetupModeOnProject = canEnableSetupMode && hasSetupPermission;

  return {
    canEnableSetupModeOnProject,
    isSetupModeEnabledOnProject: isSetupModeEnabled && canEnableSetupModeOnProject,
  };
}
